import { keepPreviousData, useQuery } from "@tanstack/react-query";

import { api, unwrap } from "../client";
import type { components } from "../generated/schema";

export type SearchGroup = components["schemas"]["SearchGroup"];
export type SearchResult = components["schemas"]["SearchResult"];

/** The header's universal search: groups the member may read, up to five results each (q ≥ 2 characters). */
export function useUniversalSearch(slug: string, q: string) {
  return useQuery({
    queryKey: ["tenant", slug, "search", q],
    enabled: q.length >= 2,
    queryFn: () => unwrap(api.GET("/api/t/{tenant_slug}/search/", { params: { path: { tenant_slug: slug }, query: { q } } })),
    placeholderData: keepPreviousData,
    staleTime: 15_000,
  });
}
